import './App.css';
import NavBar from '../Components/nav/NavBar';
import Landing from '../Pages/Landing';
import About from '../Pages/About';
import Projects from '../Pages/Projects';
import Career from '../Pages/Career';
import Skills from '../Pages/Skills';
import Contact from '../Pages/Contact';
import Footer from '../Components/footer/Footer';


function App() {
  return (
    <div className="App">
      <NavBar />
      <Landing />
      <About />
      <Projects />
      <Career />
      <Skills />
      <Contact />
      <Footer />

    </div>
  );
}

export default App;
